import type { FC } from 'react';
import styles from './Signature.module.css';
import { Great_Vibes } from 'next/font/google';
import { getClasses } from '@/_utils/classnames';
import type { SignatureProps } from './Signature.types';

export const greatvibes = Great_Vibes({
  subsets: ['latin'],
  weight: '400',
  display: 'swap',
});

export const Signature: FC<SignatureProps> = ({ name }) => {
  const signatureClasses: string = getClasses(
    styles.signature,
    greatvibes.className,
  );

  return <div className={signatureClasses}>{name}</div>;
};
